import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';

interface SectionHeadingProps {
  eyebrow: string;
  title: string;
  description?: string;
  moreTo?: string;
  moreLabel?: string;
  action?: ReactNode;
}

export default function SectionHeading({
  eyebrow,
  title,
  description,
  moreTo,
  moreLabel = '查看全部',
  action,
}: SectionHeadingProps) {
  return (
    <div className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
      <div className="max-w-2xl">
        <div className="flex items-center gap-3">
          <span className="h-px w-8 bg-primary-500"></span>
          <span className="font-label text-xs tracking-[0.3em] text-primary-400">{eyebrow}</span>
        </div>
        <h2 className="mt-3 font-heading text-xl md:text-3xl font-bold text-foreground-950">
          {title}
        </h2>
        {description && (
          <p className="mt-2 text-sm leading-relaxed text-foreground-500">{description}</p>
        )}
      </div>
      {action}
      {moreTo && !action && (
        <Link
          to={moreTo}
          className="group inline-flex shrink-0 items-center gap-2 whitespace-nowrap text-sm text-foreground-400 transition-colors hover:text-primary-400"
        >
          {moreLabel}
          <i className="ri-arrow-right-line text-base transition-transform group-hover:translate-x-1"></i>
        </Link>
      )}
    </div>
  );
}